import Icon from '../Icon';

const Spinner = () => (
  <div className='animate-spin text-gray-accent2'>
    <Icon id='loader-line' size={32} />
  </div>
);

export default Spinner;
